import { getEligibleSupportContractOptions } from "@features/run/RunModelForm/helpers"
import { UserPermissions } from "@custom-types/user"
import { ValidationError } from "utils/form"
import * as yup from "yup"
import { GraphDto, UserGraphDto } from "@custom-types/graphs"

export const SAMPLING_FIELD_MIN = 1
export const SAMPLING_FIELD_MAX = Number(import.meta.env.VITE_MAX_SAMPLINGS) || 10000

export const SEED_FIELD_MIN = 1
export const SEED_FIELD_MAX = Math.pow(2, 32) - 1

export const getValidationSchema = (
  graph: UserGraphDto | GraphDto,
  permissions: UserPermissions | undefined,
) => {
  return yup.object().shape({
    ...getSchemaShape(graph, permissions),
  })
}

export const getSchemaShape = (
  graph: UserGraphDto | GraphDto,
  permissions: UserPermissions | undefined,
) => {
  const contractOptions = getEligibleSupportContractOptions(
    graph.base_graph_family_key,
    permissions,
  )
  // user's can re-run a model if support
  return {
    run_name: yup.string().required(ValidationError.REQUIRED),
    contract_key:
      contractOptions.length > 1
        ? yup
            .string()
            .required()
            .oneOf(
              contractOptions.map((x) => x.contract_key),
              ValidationError.SELECT_ONE,
            )
        : yup.string().nullable(),
    number_of_samplings: yup
      .number()
      .typeError(ValidationError.NUMBER)
      .max(SAMPLING_FIELD_MAX)
      .min(SAMPLING_FIELD_MIN)
      .required(ValidationError.REQUIRED),
    seed: yup.number().typeError(ValidationError.NUMBER).required(ValidationError.REQUIRED),
  }
}
